import { render, staticRenderFns } from "./PricePointMain.template.vue?vue&type=template&id=7da5fe7d&scoped=true&"
var script = {}
import style0 from "./PricePointMain.template.vue?vue&type=style&index=0&id=7da5fe7d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da5fe7d",
  null
  
)

export default component.exports